module.exports = __webpack_public_path__ + "static/s4-1-hardcosts-d-b8e14b7d09fb7e1094ad39bd092e8aef.jpg";